import { Enums } from '../common/enums'

import { TypeHelper } from '../../helpers/type-helper'

import { IReferenceType, IJsonSerializable } from '../util/interfaces'

export class OpEnumObject implements IReferenceType, IJsonSerializable {
  
    // Properties

    public enumId: string
    public enumTypeName: string
    public enumName: string
    public enumText: string
    public enumValue: any
    public enumKey: any
    public description: string 

    // Properties End


    // Ctor

    constructor(opObj: any) {
        this.fromJSON(opObj)
    }
    
    // Ctor End


    // IReferenceType Implementation

    public getReferenceType(): Enums.ReferenceType {
        return Enums.ReferenceType.None //OpReferenceType.GetReferenceObjectType(this.EnumType);
    }

    public getReferenceKey(): number {
        return this.enumKey
    }

    public getReferenceValue(): any {
        return this
    }

    public toString() {
        return this.description
    }

    // IReferenceType Implementation end


    // IJsonSerializable Implementation

    public fromJSON(opObj: any, compressed: boolean = false): void {
        if (opObj != null) {
            if (compressed || TypeHelper.isJSONCompressed(opObj)) {
                this.enumId = opObj.E
                this.enumTypeName = opObj.ET
                this.enumName = opObj.EN
                this.enumText = opObj.ETE
                this.enumValue = opObj.EV
                this.enumKey = opObj.EK
                this.description = opObj.D
            }
            else {
                this.enumId = opObj.EnumId
                this.enumTypeName = opObj.EnumTypeName
                this.enumName = opObj.EnumName
                this.enumText = opObj.EnumText
                this.enumValue = opObj.EnumValue
                this.enumKey = opObj.EnumKey
                this.description = opObj.description
            }
        }
    }

    public toJSON(compressed: boolean = false): any {
        if (compressed) {
            const result: any = {
                E: this.enumId,
                ET: this.enumTypeName,
                EN: this.enumName,
                ETE: this.enumText,
                EV: this.enumValue,
                EK: this.enumKey,
                D: this.description
            }

            TypeHelper.setJSONCompressedFlag(result)
            TypeHelper.deleteNulls(result)

            return result
        }

        return {
            EnumId: this.enumId,
            EnumTypeName: this.enumTypeName,
            EnumName: this.enumName,
            EnumText: this.enumText,
            EnumValue: this.enumValue,
            EnumKey: this.enumKey,
            description: this.description
        }
    }

    // IJsonSerializable Implementation End
}